<label on:click>
    <slot/>
</label>
<style>
 label {
    display: block;
    font-size: var(--small);
    color: var(--medium-underline);
 }
</style>
